export default function formatCurrencyINR(number?: number): string {
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

  const num = number;

  const formattedCurrency = formatter.format(num || 0);

  return formattedCurrency;
}
